<svelte:head>
  
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bulma/0.8.0/css/bulma.min.css" />
  <script defer src="https://use.fontawesome.com/releases/v5.3.1/js/all.js"></script>
	<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Lato">
  <link rel="icon" href="favicon.ico" type="image/x-icon"> 
  <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png">
  <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png">
  <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png">
  <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png">
  <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png">
  <link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png">
  <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png">
  <link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png">
  <link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png">
  <link rel="icon" type="image/png" sizes="192x192"  href="/android-icon-192x192.png">
  <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
  <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png">
  <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
  <link rel="manifest" href="/manifest.json">
  <meta name="msapplication-TileColor" content="#ffffff">
  <meta name="msapplication-TileImage" content="/ms-icon-144x144.png">
  <meta name="theme-color" content="#ffffff">
  <!-- <script src="https://sdk.userbase.com/1/userbase.js"></script> -->
	<script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyByUTdqJY9dgcqL7ocjxVCwa3sS06RCPw4&libraries=places,drawing,geometry&callback=initMap"></script>
  
</svelte:head>

<script>

  import OrderForm from "./OrderForm.svelte";
  import Profile from "./Profile.svelte";
  import Notifications from 'svelte-notifications';
  export let ready;

  function toggle() {
    window.document.body.classList.toggle('dark-mode')
  }
  
</script>

<section id="top">
<!-- {#if user} -->
    <header>
        <!-- <Profile {...user} />&nbsp; &nbsp;<a on:click={ () => auth.signOut() } ><small>Logout</small></a> -->
        <Profile />
    </header>
<!-- {:else} -->

<!-- {/if} -->
</section>
<!-- 	<button on:click={toggle} class="button is-success is-small">
		Toggle Dark Mode
	</button> -->
{#if ready}
  <Notifications>
    <OrderForm />
  </Notifications>
{/if}

<style>
    section {
        /* background: rgb(66, 66, 66); */
        /* background: rgb(241, 240, 240); */
        padding: 10px;
    }

    header {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        height: 2rem;
        /* background: #cf0056; */
        /* background: #AA2444; */
        /* background-color: #383838; */
        background: #056839;
        display: flex;
        padding: 2px;
        justify-content: left;
        align-items: center;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.26);
        margin-bottom: 3rem;
        z-index: 999;
      }

      :global(body) {
        background-color: #fcfbfa;
        color: #050505;
        transition: background-color 0.3s
      }
      :global(body.dark-mode) {
        background-color: #3c3d3d;
        color: #d8d9da;
      }

</style>